<section class="bg-gradient-to-br from-Old-Rose-100 to-Old-Rose-900">
    <router-outlet></router-outlet>
    <div class="absolute bottom-0 left-0 m-2">
        <app-theme-selector></app-theme-selector>
    </div>
</section>